import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { ImgWebConfig } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const IMG_WEB_CONFIG: DiToken<ImgWebConfig> = new DiToken<ImgWebConfig>('imgWebConfig');
